import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserRequestTable } from "../../_core/_model.ts";
import { GetUserRequests } from "../../_core/_request.ts";
import LoadingOverlay from "../../UIComponents/LoadingOverlay.tsx";
import ApprovalTable from "../Tables/ApprovalTable.tsx";
import ApprovalOptions from "./ApprovalOptions.tsx";
import { useAppContext } from "../../context/AppContext.tsx";
import { allAccessRoleID } from "../../Constants.ts";

export function ApprovalWrapper() {
    const [searchParams] = useSearchParams();
    const [selectedRow, setSelectedRow] = useState<UserRequestTable>();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { dimensions } = useAppContext();


    const getDummyRoles = () => {
        let roles: any = {};
        const dConditions = {
            "D_RB_PROD": "Product Line´=´'10112'´¼",
            "D_RB_CUST": "100002",
            "D_RB_BU_SBU": "100001",
            "D_RB_OMBU": "100003",
            "D_RB_SOG": "100005"
        }
        for (var indx in dimensions) {
            let roleId = (dimensions[indx].dimensionCode == "D_RB_PROD") ? -1 : parseInt(dConditions[dimensions[indx].dimensionCode]);
            let tName = (roleId == allAccessRoleID[dimensions[indx].dimensionCode]) ? "Required all Access" : dimensions[indx].dimensionName + "=" + Math.random().toString();
            let cond = (dimensions[indx].dimensionCode != "D_RB_PROD") ? "" : dConditions[dimensions[indx].dimensionCode];
            let dim = dimensions[indx].dimensionCode;
            roles[dim] = [{
                roleID: roleId,
                roleName: tName,
                roleCode: "",
                effectiveDate: "",
                status: "",
                roleType: "",
                description: "",
                dataMapCode: dim,
                notes: "",
                dimensionName: dim,
                weight: 0,
                createdBy: 0,
                dimensionID: 0,
                changed: false,
                conditions: cond,
            }];
        }
        return roles;
    }
    useEffect(() => {
        let tId = searchParams.get("id");
        if (tId != null) {
            if (tId == "-2") {
                setSelectedRow({
                    stagingUserID: -2,
                    managerUserID: 0,
                    managerExt: "",
                    userName: "Shawn Rogers",
                    userFirstName: "Shawn",
                    userLastName: "Rogers",
                    email: "srogers@example.com",
                    role: "",
                    userExt: "11",
                    boNeeded: false,
                    requestDate: new Date().toLocaleDateString(),
                    replacingFormerUser: false,
                    formerUserID: 0,
                    status: "requested",
                    statusComment: "",
                    applicationAccess: 0,
                    bOLicenceUserID: 0,
                    internationalOnly: 0,
                    customerDimension: 0,
                    createdAt: new Date().toLocaleDateString(),
                    dimesionsRoles: getDummyRoles(),
                    sections: {},
                    userRequestedBy: 703,
                    userApprovedBy: 0,
                    roleGroups: "",
                    isAdUser: 0,
                    aComment: "",
                    rComment: "",
                    replaceRoles: false,
                    approvedAt: ""
                });
            }
            else {
                let uId = parseInt(tId);
                setLoading(true);
                GetUserRequests({
                    stagingUserID: uId,
                    userName: null,
                    status: null,
                    userRequestedBy: null,
                    userApprovedBy: null,
                    createdAt: null,
                    approvedAt: null
                }).then((x) => {
                    setSelectedRow(x.data[0]);
                    setLoading(false);
                })
            }
        }
        else
            setSelectedRow(undefined)
    }, [searchParams])

    return (
        loading ? <LoadingOverlay msg="Loading Request" /> :
            typeof selectedRow != 'undefined' ?
                <ApprovalOptions selectedUser={selectedRow} onClose={(refresh) => {
                    navigate("requests");
                }} /> :
                <ApprovalTable status={null} needButton={false} pushData={() => { }} />
    )
}

export default ApprovalWrapper;